import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { MapLink } from 'site-modules/shared/components/map-link/map-link';
import { toQueryFormattedAddress } from 'site-modules/shared/utils/address-format';
import { getMapSearchLinkFactory } from 'site-modules/shared/utils/map-utils';

export function DirectionLinkUI({
  dealerInfo,
  classes = '',
  iconClasses = 'text-gray-dark',
  isRedesign = false,
  iconWrapperClasses = '',
  mapProvider,
}) {
  const { address, name: dealerName } = dealerInfo;
  return (
    <MapLink
      location={toQueryFormattedAddress(address, dealerName)}
      mapLinkFactory={getMapSearchLinkFactory}
      className={classNames(classes, 'align-middle text-decoration-none-hover directions-link')}
      target="_blank"
      data-tracking-id="vin_view_directions"
    >
      {isRedesign ? (
        <div
          className={classNames(
            'circle-btn rounded-circle d-inline-flex justify-content-center align-items-center me-0_75',
            iconWrapperClasses
          )}
        >
          <i className={classNames('icon-location', iconClasses)} aria-hidden />
        </div>
      ) : (
        <i className={classNames('icon-location me-0_5', iconClasses)} aria-hidden />
      )}
      Directions ({mapProvider === 'apple' ? 'Apple' : 'Google'} Maps)
    </MapLink>
  );
}

DirectionLinkUI.propTypes = {
  classes: PropTypes.string,
  iconClasses: PropTypes.string,
  iconWrapperClasses: PropTypes.string,
  dealerInfo: PropTypes.shape({
    address: PropTypes.shape({
      stateName: PropTypes.string,
      city: PropTypes.string,
      street: PropTypes.string,
    }),
    name: PropTypes.string,
  }).isRequired,
  isRedesign: PropTypes.bool,
  mapProvider: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  mapProvider: state.devicePlatform.mapProvider,
});

export const DirectionLink = connect(mapStateToProps)(DirectionLinkUI);
